import { NimmstaLayout } from './NimmstaLayout';
const ERROR_LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="Error Layout">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar/>
                <icon horizontalAlignment="center" y="50" name="error_cross" align="c" />
                <cell horizontalAlignment="center" fontSize="17" wrapMode="wrap" maxLines="0" name="text"></cell>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>`;
export class ErrorLayout extends NimmstaLayout {
    constructor(text) {
        super(ERROR_LAYOUT, { text });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JMYXlvdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9sYXlvdXRzL0Vycm9yTGF5b3V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUVoRCxNQUFNLFlBQVksR0FBRzs7Ozs7Ozs7Ozs7aUJBV0osQ0FBQztBQUtsQixNQUFNLE9BQU8sV0FBWSxTQUFRLGFBQWE7SUFDNUMsWUFBWSxJQUFZO1FBQ3RCLEtBQUssQ0FBQyxZQUFZLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBQ2hDLENBQUM7Q0FDRiJ9